import qs from 'qs'
import request from '../request'

/**
 *  微信id登录
 * @author luotong
 * @date 2023-04-20 19:50
 * @param String openid
 * @return userInfo
 */

export function loginByOpenid(params){
    return request({
        url: window.g.VUE_APP_URL + '/loginByOpenid',
        method: 'post',
        params: params
    })
}

/**
 * 根据手机号码查询用户信息
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserInfoByPhone(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getUserInfoByPhone',
        method: 'get',
        params: params,
        hideLoading:true
    })
}

/**
 * 根据手机号码查询用户信息
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserInfoByPhoneNameCardID(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getUserInfoByPhoneNameCardID',
        method: 'get',
        params: params
    })
}

/**
 * 根据PatientID查询用户信息
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserInfoByPatientid(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getUserInfoByPatientid',
        method: 'get',
        params: params,
        hideLoading:true
    })
}


export function getRelativesByIdCard(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getRelativesByIdCard',
        method: 'get',
        params: params,
        hideLoading:true
    })
}

export function deleteRelatives(params) {
    return request({
        url: window.g.VUE_APP_URL + '/deleteRelatives',
        method: 'get',
        params: params
    })
}

export function editUserInfo(params) {
    return request({
        url: window.g.VUE_APP_URL + '/editUserInfo',
        method: 'post',
        data: params
    })
}

export function editRelatives(params) {
    return request({
        url: window.g.VUE_APP_URL + '/editRelatives',
        method: 'post',
        data: params
    })
}

export function addRelatives(params) {
    return request({
        url: window.g.VUE_APP_URL + '/addRelatives',
        method: 'post',
        data: params
    })
}
// 通过手机或者身份证获取用户信息，用于添加家家属
export function getPatientsByPhoneAndCode(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getPatientsByPhoneAndCode',
        method: 'get',
        params: params,
    })
}
//getCode
export function getCode(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getCode',
        method: 'get',
        params: params,
    })
}
// 发送注册验证码
export function getRegistCode(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getRegistCode',
        method: 'get',
        params: params,
    })
}
//
export function loginByPhoneCode(params) {
    return request({
        url: window.g.VUE_APP_URL + '/loginByCode',
        method: 'get',
        params: params,
    })
}
// 比对验证码（添加家属）
export function testCode(params) {
    return request({
        url: window.g.VUE_APP_URL + '/testCode',
        method: 'get',
        params: params,
    })
}
// 校验 手机号身份证姓名
export function loginByNameCardIDPhone(params) {
    return request({
        url: window.g.VUE_APP_URL + '/loginByNameCardIDPhone',
        method: 'get',
        params: params,
    })
}

//绑定手机号
export function bindingPhone(params) {
    return request({
        url: window.g.VUE_APP_URL + '/bindingPhone',
        method: 'post',
        params: params
    })
}


export function loginByPassword(params) {
    return request({
        url: window.g.VUE_APP_URL + '/loginByPassword',
        method: 'post',
        data: params,
    })
}
// 手机号 姓名 密码身份证 登录
export function loginByPasswordNameCardID(params) {
    return request({
        url: window.g.VUE_APP_URL + '/loginByPasswordNameCardID',
        method: 'post',
        data: params,
    })
}

//修改登录密码
export function updateLoginPass(params) {
    return request({
        url: window.g.VUE_APP_URL + '/updateLoginPass',
        method: 'post',
        params: params,
    })
}


//添加订单
export function addOrder(params) {
    return request({
        url: window.g.VUE_APP_URL + '/addOrder',
        method: 'post',
        data: params
    })
}
//发送His收费申请
export function sendHis(params) {
    return request({
        url: window.g.VUE_APP_URL + '/sendHis',
        method: 'get',
        params: params
    })
}


export function getOrders(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getOrders',
        method: 'get',
        params: params,
    })
}

export function getOrderDetailById(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getOrderDetailById',
        method: 'get',
        params: params,
    })
}

export function addStudentOrder(params) {
    return request({
        url: window.g.VUE_APP_URL + '/addStudentOrder',
        method: 'post',
        data: params
    })
}

export function getStudentOrder(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getStudentOrder',
        method: 'get',
        params: params,
    })
}

export function delStudentOrder(params) {
    return request({
        url: window.g.VUE_APP_URL + '/delStudentOrder',
        method: 'get',
        params: params,
    })
}
//取消订单（删除订单）
export function delOrder(params) {
    return request({
        url: window.g.VUE_APP_URL + '/delOrder',
        method: 'get',
        params: params,
    })
}

export function getOrderCount(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getOrderCount',
        method: 'get',
        params: params,
        hideLoading:true
    })
}
export function getSetBookedTime(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getSetBookedTime',
        method: 'get',
        params: params,
    })
}

/**
 * 根据手机号码查询亲属列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getRelatives(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getRelatives',
        method: 'get',
        params: params,
    })
}

/**
 * 获取登录用户信息
 * @param params
 */
export function getUserInfo(params) {
    return request({
        url: window.g.VUE_APP_URL + '/user/get_user',
        method: 'post',
        data: qs.stringify(params)
    })
}

/**
 * 获取用户所有信息
 * @param params
 */
export function getUserAllInfo(params) {
    return request({
        url: window.g.VUE_APP_URL + '/user/query',
        method: 'post',
        data: qs.stringify(params)
    })
}

/**
 *通过当前页面url获取jssdk授权配置信息
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getJssdkConfig(params) {
    return request({
        url: window.g.VUE_APP_URL + '/wechat/js',
        method: 'post',
        data: qs.stringify(params)
    })
}

/**
 * 获取用户所有信息
 * @param params
 */
export function realNameAuth(params) {
    return request({
        url: window.g.VUE_APP_URL + '/user/update',
        method: 'post',
        data: qs.stringify(params)
    })
}

/**
 * 获取用户所有信息
 * @param params
 */
export function selectArea(params) {
    return request({
        url: window.g.VUE_APP_URL + '/area/select',
        method: 'post',
        data: qs.stringify(params)
    })
}

/**
 * 获取用户所有信息
 * @param params
 */
export function getArea(params) {
    return request({
        url: window.g.VUE_APP_URL + '/area/query',
        method: 'post',
        data: qs.stringify(params)
    })
}

//查询报告
export function getReports(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getReports',
        method: 'get',
        params: params
    })
}
//查询报告base64Str
export function getReportBase64Strs(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getReportBase64Str',
        method: 'post',
        params: params
    })
}

//生成报告PDF文件
export function getPdfReport(params) {
    return request({
        url: window.g.VUE_APP_URL + '/api/getPdfReport',
        method: 'post',
        params: params
    })
}


//查询单位预约列表
export function getCompanyBookedList(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getCompanyBookedList',
        method: 'get',
        params: params
    })
}

//查询单位预约加做项目
export function getSelfCheckGroups(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getSelfCheckGroups',
        method: 'get',
        params: params
    })
}

export function updateCompany(params) {
    return request({
        url: window.g.VUE_APP_URL + '/updateCompany',
        method: 'post',
        data: params
    })
}

export function updateCancelCompany(params) {
    return request({
        url: window.g.VUE_APP_URL + '/updateCancelCompany',
        method: 'post',
        params: params
    })
}

//根据体检日期湖区时间段可预约人数
export function getBookedPeriodCount(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getBookedPeriodCount',
        method: 'get',
        params: params
    })
}
//用户注册
export function register(params){
    return request({
        url:window.g.VUE_APP_URL + '/register',
        method:'post',
        params:params
    })
}

//检查进度
export function getProcCheckProgress(params){
    return request({
        url:window.g.VUE_APP_URL + '/getProcCheckProgress',
        method:'post',
        params:params,
        hideLoading:true
    })
}
//排队数据
export function getProcGetQueueAll(params){
    return request({
        url:window.g.VUE_APP_URL + '/getProcGetQueueAll',
        method:'post',
        params:params,
        hideLoading:true
    })
}
//
export function getCurrentCheckUserInfo(params){
    return request({
        url:window.g.VUE_APP_URL + '/getCurrentCheckUserInfo',
        method:'post',
        params:params
    })
}
//根据流水号查询用户信息
export function getCurrentCheckUserInfoBySeriaoNo(params){
    return request({
        url:window.g.VUE_APP_URL + '/getCurrentCheckUserInfoBySeriaoNo',
        method:'post',
        params:params
    })
}
//解除绑定
export function unbindingWechat(params){
    return request({
        url:window.g.VUE_APP_URL + '/unbindingWechat',
        method:'post',
        params:params
    })
}

//个人预约成功发送申请后查询订单数据（融安）
export function getOrderMain(params){
    return request({
        url:window.g.VUE_APP_URL + '/getOrderMain',
        method:'get',
        params:params
    })
}

// 更改预约订单日期
//添加订单
export function UpdateOrderDate(params) {
    return request({
        url: window.g.VUE_APP_URL + '/changeCheckDate',
        method: 'post',
        data: params
    })
}

// 更改团险预约订单日期
//添加订单
export function updateOrderBookedDateUnit(params) {
    return request({
        url: window.g.VUE_APP_URL + '/updateOrderBookedDateUnit',
        method: 'post',
        data: params
    })
}
// 查询团检预约到检时间和时间段代码
export function getUnitBookedDateByBookedNo(params) {
    return request({
        url: window.g.VUE_APP_URL + '/getUnitBookedDateByBookedNo',
        method: 'get',
        params: params,
    })
}

// 更新项目状态
export function updateGroup(params) {
    return request({
        url: window.g.VUE_APP_URL + '/group/updateGroup',
        method: 'post',
        data: params,
    })
}

// 查询是否能吃早餐
export function queryIsFood(params) {
    return request({
        url: window.g.VUE_APP_URL + '/group/queryIsFood',
        method: 'get',
        params: params,
        hideLoading:true
    })
}

// 提交表单和报告发放方式
export function submitReport(params) {
    return request({
        url: window.g.VUE_APP_URL + '/group/submitReport',
        method: 'post',
        data: params,
    })
}

// 查询是否能领取停车卷
export function getParking(params) {
    return request({
        url: window.g.VUE_APP_URL + '/parking/getParking',
        method: 'get',
        params: params,
        hideLoading:true
    })
}

// 提交车牌号
export function addParking(params) {
    return request({
        url: window.g.VUE_APP_URL + '/parking/addParking',
        method: 'post',
        data: params,
    })
}
